// 3rd party chatbot.
//
// This is neither a service nor a provider. We model it as a constant
// since we need to inject into a configuration before the app boots up.
class ChatScript {
  constructor(config) {
    this.config = config;
    this.initialized = false;
  }

  createPayload() {
    const user = JSON.parse(sessionStorage.getItem('dimsum.user') || null);
    const purchasingAccount = JSON.parse(sessionStorage.getItem('dimsum.purchasingAccountData') || null);
    return { user, purchasingAccount };
  }

  initialize() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.loadChat(this.config.env === 'local' ? 'qalv' : this.config.env);
  }


  loadChat(sdlc) {
    const chatStyleHref =
      (sdlc.toLowerCase() === 'prod'|| sdlc.toLowerCase() === 'qalv')
        ? 'https://chat.mcgrawhill-west.onereach.ai/lib/richWebChat.css'
        : 'https://chat.mcgrawhill-staging.onereach.ai/lib/richWebChat.css';
    const chatStyle = document.createElement('link');
    chatStyle.setAttribute('id', 'chat-style');
    chatStyle.setAttribute('rel', 'stylesheet');
    chatStyle.setAttribute('href', chatStyleHref);
    document.body.appendChild(chatStyle);

    const isProductionLike = sdlc.toLowerCase() === 'prod' || sdlc.toLowerCase() === 'qalv';

    if (!isProductionLike) {
      const chatSettingsStyleHref = 'https://files.mcgrawhill-staging.api.onereach.ai/public/ed5398e8-cee9-40de-acd2-b41149f00632/RWC-MGH-SETTINGS/am_custom/am_customORstyles.css';
      const chatSettingsStyle = document.createElement('link');
      chatSettingsStyle.setAttribute('id', 'chat-settings-style');
      chatSettingsStyle.setAttribute('rel', 'stylesheet');
      chatSettingsStyle.setAttribute('href', chatSettingsStyleHref);
      document.body.appendChild(chatSettingsStyle);

      const focusFeatureScript = document.createElement('script');
      focusFeatureScript.async = true;
      focusFeatureScript.setAttribute('id', 'chat-focus-feature');
      focusFeatureScript.setAttribute(
        'src',
        'https://files.mcgrawhill-staging.api.onereach.ai/public/ed5398e8-cee9-40de-acd2-b41149f00632/RWC-MGH-SETTINGS/am_custom/am_focusFeature.js',
      );
      document.body.appendChild(focusFeatureScript);

      const minButtonScript = document.createElement('script');
      minButtonScript.async = false;
      minButtonScript.setAttribute('id', 'chat-min-button');
      minButtonScript.setAttribute(
        'src',
        'https://files.mcgrawhill-staging.api.onereach.ai/public/ed5398e8-cee9-40de-acd2-b41149f00632/RWC-MGH-SETTINGS/am_custom/am_minButtonCustom.js',
      );
      document.body.appendChild(minButtonScript);

      const autoOpenerScript = document.createElement('script');
      autoOpenerScript.async = false;
      autoOpenerScript.setAttribute('id', 'chat-auto-opener');
      autoOpenerScript.setAttribute(
        'src',
        'https://files.mcgrawhill-staging.api.onereach.ai/public/ed5398e8-cee9-40de-acd2-b41149f00632/RWC-MGH-SETTINGS/am_custom/am_vigetAutoOpener.js',
      );
      document.body.appendChild(autoOpenerScript);
    } else {
      const prodBaseUrl = 'https://files.mcgrawhill-west.api.onereach.ai/public/c21601e3-8bab-4ec7-a323-83e2c64fdb78/_RWC_custom_/am_custom';

      const chatSettingsStyle = document.createElement('link');
      chatSettingsStyle.setAttribute('id', 'chat-settings-style');
      chatSettingsStyle.setAttribute('rel', 'stylesheet');
      chatSettingsStyle.setAttribute('href', `${prodBaseUrl}/am_customORstyles.css`);
      document.body.appendChild(chatSettingsStyle);

      const focusFeatureScript = document.createElement('script');
      focusFeatureScript.async = true;
      focusFeatureScript.setAttribute('id', 'chat-focus-feature');
      focusFeatureScript.setAttribute('src', `${prodBaseUrl}/am_focusFeature.js`);
      document.body.appendChild(focusFeatureScript);

      const minButtonScript = document.createElement('script');
      minButtonScript.async = false;
      minButtonScript.setAttribute('id', 'chat-min-button');
      minButtonScript.setAttribute('src', `${prodBaseUrl}/am_minButtonCustom.js`);
      document.body.appendChild(minButtonScript);

      const autoOpenerScript = document.createElement('script');
      autoOpenerScript.async = false;
      autoOpenerScript.setAttribute('id', 'chat-auto-opener');
      autoOpenerScript.setAttribute('src', `${prodBaseUrl}/am_vigetAutoOpener.js`);
      document.body.appendChild(autoOpenerScript);
    }

    const chatScriptSrc =
      (sdlc.toLowerCase() === 'prod'|| sdlc.toLowerCase() === 'qalv')
        ? 'https://chat.mcgrawhill-west.onereach.ai/lib/richWebChat.umd.min.js'
        : 'https://chat.mcgrawhill-staging.onereach.ai/lib/richWebChat.umd.min.js';
    const chatTag1 = document.createElement('script');
    chatTag1.async = false;
    chatTag1.setAttribute('id', 'rwc-embed-script');
    chatTag1.setAttribute('src', chatScriptSrc);
    document.body.appendChild(chatTag1);

    const closeChatbotScript = document.createElement('script');
    closeChatbotScript.setAttribute('type', 'text/javascript');
    closeChatbotScript.setAttribute('id', 'close-chatbot');
    closeChatbotScript.setAttribute('src', 'assets/chat/close-chatbot-handle.js');
    document.body.appendChild(closeChatbotScript);

    const chatTagMeta = document.createElement('meta');
    chatTagMeta.setAttribute('name', 'viewport');
    chatTagMeta.setAttribute('content', 'width=device-width, initial-scale=1');
    document.body.appendChild(chatTagMeta);

    chatTag1.onload = () => {
      const payload = this.createPayload();
      if (sdlc.toLowerCase() === 'prod'|| sdlc.toLowerCase() === 'qalv') {
        this.initEmbedChatProd(payload);
      } else {
        this.initEmbedChat(payload);
      }
    };
  }

  initEmbedChat(payload) {
    if (window.isRwcEmbedLoaded || !richWebChat) {
      return;
    }

    window.isRwcEmbedLoaded = true;

    var RWC = richWebChat.default;
    window.livechat = new RWC({
      container: '#rwc',
      chatUrl: 'https://chat.mcgrawhill-staging.onereach.ai/7VOY6M7pQN6s0rQRSfAGMg/0kcxf85?loader=light&continueSession=true',

      appearance: {
        blurredBackground: false,
        resizeable: false,
        draggable: true,
        saveChatSize: true,
        preloadInBackground: false,
      },

      widget: {
        position: 'bottom-right',
        animation: 'none',
        color: '#D32F2F',
        logoUrl: '',
        revealDelay: 0,
        openDelay: 0,
        openChatAriaLabel: 'Open chat',
      },

      invitation: {
        closeable: false,
        imageUrl: '',
        message: '',
        buttonLabel: '',
        appearDelay: 0,
        soundLocation: '',
      },

      pageData: {
        userData: payload
      },
    });

    this.setupAccessibilityHandlers();
  }

  initEmbedChatProd(payload) {
    if (window.isRwcEmbedLoaded || !richWebChat) {
      return;
    }

    window.isRwcEmbedLoaded = true;

    var RWC = richWebChat.default;
    window.livechat = new RWC({
      container: '#rwc',
      chatUrl: 'https://chat.mcgrawhill-west.onereach.ai/whYB44urTsejI4Pixk_beA/0kcxf85?loader=light&continueSession=true',

      appearance: {
        blurredBackground: false,
        resizeable: false,
        draggable: true,
        saveChatSize: true,
        preloadInBackground: false,
      },

      widget: {
        position: 'bottom-right',
        animation: 'none',
        color: '#D32F2F',
        logoUrl: '',
        revealDelay: 0,
        openDelay: 0,
        openChatAriaLabel: 'Open chat',
      },

      invitation: {
        closeable: false,
        imageUrl: '',
        message: '',
        buttonLabel: '',
        appearDelay: 0,
        soundLocation: '',
      },

      pageData: {
        userData: payload
      },
    });

    this.setupAccessibilityHandlers();
  }

  setupAccessibilityHandlers() {
    function focusWidgetButton() {
      var rwc = document.getElementById('rwc');
      if (!rwc) return;

      var btn = document.querySelector('#rwc > div > button');
      if (btn) {
        btn.focus();
        return;
      }

      var observer = new MutationObserver(function () {
        var btn = document.querySelector('#rwc > div > button');
        if (btn) {
          observer.disconnect();
          btn.focus();
        }
      });
      observer.observe(rwc, { childList: true, subtree: true });

      setTimeout(function () {
        observer.disconnect();
      }, 2000);
    }

    function handleClose() {
      window.livechat.root.closeChat();
      setTimeout(focusWidgetButton, 300);
    }

    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27 || e.which === 27) {
        handleClose();
      }
    });

    window.addEventListener('message', function (e) {
      if (!e.data || e.data.type !== '__rwc_escape_key__') return;
      handleClose();
    });
  }
}

export default ChatScript;



// WEBPACK FOOTER //
// ./app/constants/chatScript.js